import './App.css';
import './main.css';
import { createBrowserRouter, RouterProvider, Outlet, Navigate } from 'react-router-dom';
import ScanDashboard from './pages/ScanDashboard';
const Layout = () => (
  <div>
    <Outlet />
  </div>
);

const App = () => {
  const router = createBrowserRouter([
    {
      path: '/',
      element: <Layout />,
      children: [
        {
          path: '/',
          element: <ScanDashboard />,
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
};

export default App;
